import React from "react";
import {useEffect, useState} from "react";

export default (props) => {// this page will shown if there is an error occurs in the backend.
    const [PageDetails, setPageDetails] = useState({
        ImageUrl: `${process.env.PUBLIC_URL + "/Images/SomethingWentWrong.gif"}`,
        Message: 'This page is currently not available. We are working on the problem, Appreciate your patience'
    })
    useEffect(() => {
        if (props.ImageUrl !== undefined) {
            setPageDetails({
                ...PageDetails,
                ImageUrl: props.ImageUrl,
            });
        }
        if (props.Message !== undefined) {
            setPageDetails({
                ...PageDetails,
                Message: props.Message,
            });
        }
    }, [])
    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 blue-background-color">
            <div className="row">
                <div className="col d-flex justify-content-center align-items-center text-white">
                    <img src={PageDetails.ImageUrl} width='150' alt="Something Went Wrong.."/>
                    <div>
                        <h2>Something went wrong. Try again in a few minutes</h2>
                        <h4 className='text-dark'>{PageDetails.Message}</h4>
                    </div>
                </div>
            </div>
        </div>
    )
};